<template>
  <article id="crypto">
    <div id="list-item">
      <div class="col-name-time">
        <div class="name">xxxx</div>
        <div class="date">
          <i class="fal fa-clock"></i>
          {{ 2019/12/18 }}
        </div>
      </div>
      <div class="col-percent-day">
        <div class="percent plus">100 %</div>
        <div class="day">1 Year</div>
      </div>
      <div class="col-amount">
        <div class="money">999,999 ฿</div>
      </div>
      <i id="chevron" class="fas fa-chevron-right"></i>
    </div>
    <div id="list-item">
      <div class="col-name-time">
        <div class="name">xxxx</div>
        <div class="date">
          <i class="fal fa-clock"></i>
          {{ 2019/12/18 }}
        </div>
      </div>
      <div class="col-percent-day">
        <div class="percent minus">100 %</div>
        <div class="day">1 Year</div>
      </div>
      <div class="col-amount">
        <div class="money">999,999 ฿</div>
      </div>
      <i id="chevron" class="fas fa-chevron-right"></i>
    </div>
    <div id="list-item">
      <div class="col-name-time">
        <div class="name">xxxx</div>
        <div class="date">
          <i class="fal fa-clock"></i>
          {{ 2019/12/18 }}
        </div>
      </div>
      <div class="col-percent-day">
        <div class="percent plus">100 %</div>
        <div class="day">1 Year</div>
      </div>
      <div class="col-amount">
        <div class="money">999,999 ฿</div>
      </div>
      <i id="chevron" class="fas fa-chevron-right"></i>
    </div>
    <div id="list-item">
      <div class="col-name-time">
        <div class="name">xxxx</div>
        <div class="date">
          <i class="fal fa-clock"></i>
          {{ 2019/12/18 }}
        </div>
      </div>
      <div class="col-percent-day">
        <div class="percent plus">100 %</div>
        <div class="day">1 Year</div>
      </div>
      <div class="col-amount">
        <div class="money">999,999 ฿</div>
      </div>
      <i id="chevron" class="fas fa-chevron-right"></i>
    </div>
    <div id="list-item">
      <div class="col-name-time">
        <div class="name">xxxx</div>
        <div class="date">
          <i class="fal fa-clock"></i>
          {{ 2019/12/18 }}
        </div>
      </div>
      <div class="col-percent-day">
        <div class="percent minus">100 %</div>
        <div class="day">1 Year</div>
      </div>
      <div class="col-amount">
        <div class="money">999,999 ฿</div>
      </div>
      <i id="chevron" class="fas fa-chevron-right"></i>
    </div>
    <div id="list-item">
      <div class="col-name-time">
        <div class="name">xxxx</div>
        <div class="date">
          <i class="fal fa-clock"></i>
          {{ 2019/12/18 }}
        </div>
      </div>
      <div class="col-percent-day">
        <div class="percent plus">100 %</div>
        <div class="day">1 Year</div>
      </div>
      <div class="col-amount">
        <div class="money">999,999 ฿</div>
      </div>
      <i id="chevron" class="fas fa-chevron-right"></i>
    </div>
    <div id="list-item">
      <div class="col-name-time">
        <div class="name">xxxx</div>
        <div class="date">
          <i class="fal fa-clock"></i>
          {{ 2019/12/18 }}
        </div>
      </div>
      <div class="col-percent-day">
        <div class="percent plus">100 %</div>
        <div class="day">1 Year</div>
      </div>
      <div class="col-amount">
        <div class="money">999,999 ฿</div>
      </div>
      <i id="chevron" class="fas fa-chevron-right"></i>
    </div>
    <div id="list-item">
      <div class="col-name-time">
        <div class="name">xxxx</div>
        <div class="date">
          <i class="fal fa-clock"></i>
          {{ 2019/12/18 }}
        </div>
      </div>
      <div class="col-percent-day">
        <div class="percent minus">100 %</div>
        <div class="day">1 Year</div>
      </div>
      <div class="col-amount">
        <div class="money">999,999 ฿</div>
      </div>
      <i id="chevron" class="fas fa-chevron-right"></i>
    </div>
    <div id="list-item">
      <div class="col-name-time">
        <div class="name">xxxx</div>
        <div class="date">
          <i class="fal fa-clock"></i>
          {{ 2019/12/18 }}
        </div>
      </div>
      <div class="col-percent-day">
        <div class="percent plus">100 %</div>
        <div class="day">1 Year</div>
      </div>
      <div class="col-amount">
        <div class="money">999,999 ฿</div>
      </div>
      <i id="chevron" class="fas fa-chevron-right"></i>
    </div>
    <div id="list-item">
      <div class="col-name-time">
        <div class="name">xxxx</div>
        <div class="date">
          <i class="fal fa-clock"></i>
          {{ 2019/12/18 }}
        </div>
      </div>
      <div class="col-percent-day">
        <div class="percent plus">100 %</div>
        <div class="day">1 Year</div>
      </div>
      <div class="col-amount">
        <div class="money">999,999 ฿</div>
      </div>
      <i id="chevron" class="fas fa-chevron-right"></i>
    </div>
    <div id="list-item">
      <div class="col-name-time">
        <div class="name">xxxx</div>
        <div class="date">
          <i class="fal fa-clock"></i>
          {{ 2019/12/18 }}
        </div>
      </div>
      <div class="col-percent-day">
        <div class="percent minus">100 %</div>
        <div class="day">1 Year</div>
      </div>
      <div class="col-amount">
        <div class="money">999,999 ฿</div>
      </div>
      <i id="chevron" class="fas fa-chevron-right"></i>
    </div>
    <div id="list-item">
      <div class="col-name-time">
        <div class="name">xxxx</div>
        <div class="date">
          <i class="fal fa-clock"></i>
          {{ 2019/12/18 }}
        </div>
      </div>
      <div class="col-percent-day">
        <div class="percent plus">100 %</div>
        <div class="day">1 Year</div>
      </div>
      <div class="col-amount">
        <div class="money">999,999 ฿</div>
      </div>
      <i id="chevron" class="fas fa-chevron-right"></i>
    </div>
    <div id="list-item">
      <div class="col-name-time">
        <div class="name">xxxx</div>
        <div class="date">
          <i class="fal fa-clock"></i>
          {{ 2019/12/18 }}
        </div>
      </div>
      <div class="col-percent-day">
        <div class="percent minus">100 %</div>
        <div class="day">1 Year</div>
      </div>
      <div class="col-amount">
        <div class="money">999,999 ฿</div>
      </div>
      <i id="chevron" class="fas fa-chevron-right"></i>
    </div>
    <div id="list-item">
      <div class="col-name-time">
        <div class="name">xxxx</div>
        <div class="date">
          <i class="fal fa-clock"></i>
          {{ 2019/12/18 }}
        </div>
      </div>
      <div class="col-percent-day">
        <div class="percent minus">100 %</div>
        <div class="day">1 Year</div>
      </div>
      <div class="col-amount">
        <div class="money">999,999 ฿</div>
      </div>
      <i id="chevron" class="fas fa-chevron-right"></i>
    </div>
    <ModalComming type="crypto" />
  </article>
</template>
<script>
import ModalComming from "../../../../components/miniapp/global/ModalComming";
import ListMarket from "../../../../components/miniapp/market/List";

import { mapGetters, mapActions } from "vuex";
export default {
  components: {
    ListMarket,
    ModalComming
  },
  data() {
    return {};
  }
};
</script>
<style lang="scss" scoped>
#crypto {
  @extend %container-style;
  // position: relative;
  pointer-events: none;
  h2 {
    @extend %font-size-m;
    font-weight: bold;
    margin-bottom: 10px;
    color: $color-normal-text;
  }
  #section-filter-fund {
    margin: 12px 15px;
    .filter-left {
      @include finCol(10, 12, 8px, middle, true, false);
    }
    .filter-right {
      @include finCol(2, 12, 8px, middle, false, true);
    }
    .filter-ctn {
      border-radius: 6px;
      background-color: #efefef;
      padding: 13.5px 16px;
      display: block;
      text-align: center;
      color: $color-normal-text;
      font-size: 12px;
      box-shadow: 0 0 4px 0 #f9f9f9;
      @media screen and (min-width: 480px) {
        min-height: 53px;
      }
      .filtered {
        color: $color-orange-finno;
      }
    }
  }
  #section-filter-tags {
    position: relative;
    margin-bottom: 12px;
    .filter-tags-box {
      border-radius: 21.5px;
      background-color: #f9f9f9;
      padding: 4px 32px 4px 16px;
      white-space: nowrap;
      overflow: hidden;
      text-overflow: ellipsis;
      .tags-label {
        display: inline-block;
        @extend %font-size-s;
        font-weight: bold;
        margin-right: 10px;
      }
      .tags-list {
        list-style: none;
        margin: 0;
        padding: 0;
        display: inline;
        .tags-item {
          display: inline-block;
          @extend %font-size-s;
          color: $color-normal-text;
          &:not(:last-child) {
            &:after {
              content: ",";
              width: 5px;
              height: 5px;
              margin-right: 10px;
            }
          }
        }
      }
    }
    .reset-filter {
      position: absolute;
      right: 25px;
      top: 5px;
      i {
        color: $color-light-grey-2;
      }
    }
  }
  #list-item {
    filter: blur(4px);
    padding-right: 0px;
    padding-left: 0px;
    margin: 0 0;
    padding: 0 24px;
    width: 100%;
    display: flex;
    justify-content: center;
    border-bottom: 1px solid $color-line-grey;
    pointer-events: auto;
    .col-amount,
    .col-name-time,
    .col-percent-day {
      pointer-events: none;
      display: flex;
      flex-direction: column;
      justify-content: center;
      width: 31%;
      height: 65px;
      .percent,
      .name,
      .money,
      .loading {
        height: 22px;
      }
    }
    .col-name-time {
      pointer-events: none;
      .name {
        @extend %font-size-s;
        font-weight: bold;
        color: $color-normal-text;
        white-space: nowrap;
        overflow: hidden;
        text-overflow: ellipsis;
      }
      .date {
        color: $color-secondary;
        @extend %font-size-ss;
      }
    }
    .col-percent-day {
      pointer-events: none;
      .percent {
        @extend %font-size-s;
        text-align: right;
      }
      .day {
        @extend %font-size-ss;
        color: $color-secondary;
        text-align: right;
      }
    }
    .col-amount {
      pointer-events: none;
      .money {
        color: $color-normal-text;
        @extend %font-size-s;
        text-align: right;
      }
      .loading {
        padding-right: 10px;
        text-align: right;
        i {
          text-align: center;
          font-size: 16px;
          color: $color-light-grey-2;
        }
      }
    }
    #chevron {
      pointer-events: none;
      width: 7%;
      text-align: center;
      display: flex;
      flex-direction: column;
      justify-content: center;
      font-size: 10px;
      color: $color-light-grey-2;
      position: relative;
      left: 10px;
      z-index: -1;
    }
  }
}
</style>